const f = ["jpg", "jpeg", "png"], _ = (n = "", t) => {
  if (!n.includes("res.cloudinary")) return n;
  t = Object.fromEntries(
    Object.entries(t).filter(([e, r]) => r)
  ), t = Object.assign({
    format: "auto",
    quality: "auto"
  }, t);
  const c = {
    crop: "c_",
    format: "f_",
    gravity: "g_",
    height: "h_",
    quality: "q_",
    width: "w_",
    x: "x_",
    y: "y_"
  }, i = Object.keys(t).map((e) => c[e] + t[e]).join(","), [, s, o, a] = n.match(
    /^(.+\/image\/upload)\/.+\/(.+\/.+)\.(.+)$/
  ), u = f.includes(a) ? a : "png";
  return `${s}/${i}/${o}.${u}`;
};
export {
  _ as default
};
